import {captureException} from '@zzng/common/utils/matrix';

import {JsonataCustomFunctions} from '@/shared/utils/jsonata';

export const MONTH_PER_YEAR = 12;

export const DAY_PER_MONTH = 30;

type Period = {
  years: number;
  months: number;
  days: number;
};

const daysInMonth = (year: number, month: number) => {
  return new Date(year, month, 0).getDate();
};

const calculateDateDifference = (startDateStr: string, endDateStr: string | null): Period => {
  const startDate = new Date(startDateStr);
  const endDate = endDateStr ? new Date(endDateStr) : new Date();

  let years = endDate.getFullYear() - startDate.getFullYear();
  let months = endDate.getMonth() - startDate.getMonth();
  let days = endDate.getDate() - startDate.getDate() + 1; // 시작일 포함

  if (days < 0) {
    days += daysInMonth(startDate.getFullYear(), startDate.getMonth() + 1);
    months--;
  }

  // 30일 이상인 경우 1개월로 변환
  if (days >= DAY_PER_MONTH) {
    days = 0;
    months++;
  }

  if (months < 0) {
    months += MONTH_PER_YEAR;
    years--;
  }

  if ([years, months, days].some((v) => v < 0)) {
    captureException(`기간 계산에서 음수가 발생했습니다. startDate: ${startDateStr}, endDate: ${endDateStr}`);
  }

  return {
    years,
    months,
    days
  };
};

const formatPeriod = (period: Period) => {
  if (period.years && period.months) {
    return `${period.years}년 ${period.months}개월`;
  }

  if (period.years) {
    return `${period.years}년`;
  }

  if (period.months) {
    return `${period.months}개월`;
  }

  return `${period.days}일`;
};

export const calculatePeriod: JsonataCustomFunctions['calculatePeriod'] = (start, end) => {
  const period = calculateDateDifference(start, end);
  return formatPeriod(period);
};
